import {observer} from "mobx-react";
import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import ButtonNew from "@dropDesk/presentation/components/buttons/button_new";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {Tooltip} from "antd";
import {useBetween} from "use-between";
import {
    useModalsReportTicketComparative
} from "@dropDesk/presentation/pages/reports/report_ticket_init/report_ticket_comparative/ui/modals/handle_change_visible";
import {
    ActionsGroup,
    HeaderContainer,
    Subtitle,
    Title,
    TitleGroup,
    TitleRow,
} from "./styled";
import {ClientEntity} from "@dropDesk/domain/entities/client/client.entity";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";
import {
    TicketsDescriptionStaticEntity
} from "@dropDesk/domain/entities/ticket_description_static/ticket_description_static.entity";
import ReportEntityFiltersButton from "@dropDesk/presentation/components/filters/report_entity_filters";

const HeaderComparative = observer(({
    loading,
    hasReport,
    filterClient,
    filterUserClient,
    filterSector,
    filterAttendant,
    filterDescriptionStatic,
    setFilterClient,
    setFilterUserClient,
    setFilterSector,
    setFilterAttendant,
    setFilterDescriptionStatic,
    onClearFilters,
}: {
    loading: boolean;
    hasReport: boolean;
    filterClient: ClientEntity | null;
    filterUserClient: UserEntity | null;
    filterSector: SectorEntity | null;
    filterAttendant: UserEntity | null;
    filterDescriptionStatic: TicketsDescriptionStaticEntity | null;
    setFilterClient: (filter: ClientEntity | null) => void;
    setFilterUserClient: (filter: UserEntity | null) => void;
    setFilterSector: (filter: SectorEntity | null) => void;
    setFilterAttendant: (filter: UserEntity | null) => void;
    setFilterDescriptionStatic: (filter: TicketsDescriptionStaticEntity | null) => void;
    onClearFilters: () => void;
}) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    const {setVisibleModalExportHtml} = useBetween(useModalsReportTicketComparative);

    return (
        <HeaderContainer>
            <TitleGroup>
                <TitleRow>
                    <Title color={colors.text}>Relatório Comparativo</Title>
                    <Tooltip title="Compare dois períodos para acompanhar a evolução dos atendimentos. Veja melhorias ou quedas em volume, tempo de resposta, solução, satisfação e desempenho da equipe.">
                        <div>
                            <DropDeskIcon
                                icon={ICONS_DROPDESK.info}
                                size={16}
                                color={colors.hintInverse}
                            />
                        </div>
                    </Tooltip>
                </TitleRow>
                <Subtitle color={colors.hintInverse}>Compare o desempenho de atendimentos entre dois períodos</Subtitle>
            </TitleGroup>

            <ActionsGroup>
                <ReportEntityFiltersButton
                    filterClient={filterClient}
                    filterUserClient={filterUserClient}
                    filterSector={filterSector}
                    filterAttendant={filterAttendant}
                    filterDescriptionStatic={filterDescriptionStatic}
                    setFilterClient={setFilterClient}
                    setFilterUserClient={setFilterUserClient}
                    setFilterSector={setFilterSector}
                    setFilterAttendant={setFilterAttendant}
                    setFilterDescriptionStatic={setFilterDescriptionStatic}
                    loading={loading}
                    onClear={onClearFilters}
                    radius={4}
                    marginLeft={0}
                />
                <Tooltip title={!hasReport ? 'Não possui dados' : ''}>
                    <div>
                        <ButtonNew
                            size={37}
                            label={'Exportar relatório'}
                            onClick={() => setVisibleModalExportHtml(true)}
                            nameLeftIcon={ICONS_DROPDESK.documentOutline}
                            sizeLeftIcon={15}
                            disabled={loading || !hasReport}
                        />
                    </div>
                </Tooltip>
            </ActionsGroup>
        </HeaderContainer>
    );
});

export default HeaderComparative;
